import { OreButton, OreHeading, OreStack, OreText, SvgDownload } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'

export const Step2Form = (): JSX.Element => {
  const { t } = useTranslation()
  const { downloadSepaDocument } = useBankAccount()

  return (
    <OreStack space="large">
      <OreHeading size="headline-md">
        {t(contractTranslation.changeBankAccount.step2.title)}
      </OreHeading>
      <OreText>{t(contractTranslation.changeBankAccount.step2.sepaIntroduction)}</OreText>
      <OreStack>
        <OreButton
          data-testid="downloadSepaDocument"
          category="secondary"
          icon={<SvgDownload />}
          onClick={() => downloadSepaDocument()}
        >
          {t(contractTranslation.changeBankAccount.step2.downloadSepa.label)}
        </OreButton>
      </OreStack>
    </OreStack>
  )
}
